export { default } from './ProjectPartners';



// WEBPACK FOOTER //
// ./src/components/ProjectPartners/index.js